<div class="main-container" [attr.data-testid]="ELEMENT_IDS['main']">
  <div class="left-container" [attr.data-testid]="ELEMENT_IDS['left']">
    <app-custom-slider
      [attr.data-testid]="ELEMENT_IDS['slider']"
      [sliderData]="sliderData"
      style="width: 100%; height: 100%; margin-bottom: 100px"
    ></app-custom-slider>
  </div>
  <div class="right-container" [attr.data-testid]="ELEMENT_IDS['right']">
    <div class="content-container" [attr.data-testid]="ELEMENT_IDS['content']">
      @if(mode === 'login'){
      <div class="header-container" [attr.data-testid]="ELEMENT_IDS['hdr']">
        <div class="logo-container" [attr.data-testid]="ELEMENT_IDS['sec_logo']">
          <img
            src="assets/images/escience-logo-1.png"
            alt="E-Science Logo"
            [attr.data-testid]="ELEMENT_IDS['img_logo']"
          />
        </div>
        <h3 class="title" i18n [attr.data-testid]="ELEMENT_IDS['lbl_title']">Welcome!</h3>
        <h6 class="subtitle" i18n [attr.data-testid]="ELEMENT_IDS['lbl_subtitle']">Access is provided by your administrator</h6>
      </div>
      <form class="form-container" [formGroup]="loginForm" (submit)="onSubmit()" [attr.data-testid]="ELEMENT_IDS['form']">
        <app-custom-input
            label="Login Email"
            controlName="username"
            icon="person"
            iconPlacement="left"
            [elementId]="ELEMENT_IDS['input_username']"
        >
            <ng-template #errorsTemplate />
        </app-custom-input>
        <app-custom-input
            label="Password"
            controlName="password"
            icon="lock"
            iconPlacement="left"
            [type]="showPassword ? 'text' : 'password'"
            [actionIcon]="showPassword ? 'visibility' : 'visibility_off'"
            [actionElementId]="ELEMENT_IDS['btn_toggle_password']"
            (onActionClick)="toggleShowPassword()"
            [hideSubscript]="true"
            [elementId]="ELEMENT_IDS['input_password']"
        >
            <ng-template #errorsTemplate />
        </app-custom-input>
        <span class="forgot-password">
            <span class="forgot-password-button" (click)="onForgotPassword()" [attr.data-testid]="ELEMENT_IDS['lnk_forgot_password']">
                Forgot Password?
            </span>
        </span>
        @if (errorMessage) {
        <p class="error-message" @fadeInOut [attr.data-testid]="ELEMENT_IDS['msg_error']">{{errorMessage}}</p>
        }
        <div class="button-container">
            <app-custom-button
                [elementId]="ELEMENT_IDS['btn_sign_in']"
                buttonType="primary"
                text="Sign in"
                [loading]="loading"
                [isSubmit]="true"
            ></app-custom-button>
        </div>
      </form>
      } @else if(mode === 'select-warehouse'){
      <app-select-warehouse
        class="component-container"
        [attr.data-testid]="ELEMENT_IDS['sec_select_warehouse']"
        [warehouseList]="warehouseList"
        (onSubmitEmitter)="onWarehouseSelect($event)"
      ></app-select-warehouse>
      } @else if(mode === 'forgot-password'){
      <app-forgot-password
        class="component-container"
        [attr.data-testid]="ELEMENT_IDS['sec_forgot_password']"
        [fpData]="fpInitData">
      </app-forgot-password>

      } @else {
      <app-update-password
        class="component-container"
        [attr.data-testid]="ELEMENT_IDS['sec_update_password']"
        [username]="loginForm.value.username"
        [temporaryPassword]="loginForm.value.password"
      ></app-update-password>
      }
    </div>
    <div class="footer" [attr.data-testid]="ELEMENT_IDS['ftr']">
      <p [attr.data-testid]="ELEMENT_IDS['lbl_copyright']">© Electronic Science. All Rights Reserved</p>
      <p>
        <span [attr.data-testid]="ELEMENT_IDS['lbl_version']">Version {{ appVersion }}</span> |
        <a class="privacy-policy" routerLink="/privacy-policy" [attr.data-testid]="ELEMENT_IDS['lnk_privacy_policy']"
          >Privacy Policy</a
        >
      </p>
    </div>
  </div>
</div>
